import React from 'react'
import { useFormContext, validateForm } from './formUtils'
import { Box, Button, Icon } from '@maui/elements'
import { StepNavigator } from '../common/StepNavigator'

import AnalystInvestigation1 from './AnalystInvestigation1'
import AnalystInvestigation2 from './AnalystInvestigation2'

export default function FormWizard() {
  const { step, handleNext, handlePrev, mode, state, onClose, onSubmit, isSubmitting, setRequestType } = useFormContext()
  const steps = [AnalystInvestigation1, AnalystInvestigation2]
  const isLastStep = step === steps.length - 1
  const error = validateForm(state, step)
  const handleForm = React.useCallback((e) => {
    e.preventDefault()
    if (!isLastStep && !error) {
      handleNext()
    } else if (!error && isLastStep) {
      onSubmit()
    }
  }, [isLastStep, handleNext, onSubmit, error])
  const submitText = isSubmitting ? 'Submitting...' : 'Submit'

  return (
    <form onSubmit={handleForm} name='analystInvestigationForm'>
      {mode === 'drawer' &&
        <StepNavigator>
          <Box display='flex' flex='1' alignItems='center'>
            <Button variant='secondary' onClick={onClose}>
            Cancel
            </Button>
          </Box>
          <Button variant="secondary" onClick={() => step === 0 ? setRequestType('new') : handlePrev()}>
            <Box display="flex">
              <Icon name='left-arrow' size="sm" mr="10px" mt="1px"/>
                    Back
            </Box>
          </Button>
          <Button ml="spaceGapXLarge" type="submit" disabled={error || isSubmitting}>
            {isLastStep
              ? submitText
              : <Box display="flex">
                  Next
                <Icon name='left-arrow' size="sm" ml="10px" mt="1px" style={{ transform: 'rotate(-180deg)' }}/>
              </Box>}
          </Button>
        </StepNavigator>
      }
      <Box mt='spaceGapLarge'>
        <Box display={step === 0 ? 'block' : 'none'}>
          <AnalystInvestigation1 />
        </Box>
        <Box display={step === 1 ? 'block' : 'none'}>
          <AnalystInvestigation2 />
        </Box>
      </Box>
      {mode === 'page' &&
        <Box display="flex" gap="12px" mt="16px">
          <Button
            variant="secondary"
            onClick={() => step === 0 ? setRequestType('new') : handlePrev()}
            display="flex"
            alignItems="center"
            gap="10px"
          >
            <Icon name='left-arrow' size="sm" /> Back
          </Button>
          <Button
            type="submit"
            disabled={error || isSubmitting}
            display="flex"
            alignItems="center"
            gap="10px"
          >
            {isLastStep
              ? submitText
              : <>Next <Icon name='left-arrow' size="sm" transform="rotate(-180deg)" /></>
            }
          </Button>
        </Box>
      }
    </form>
  )
}
